import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import assets from '../assets';

const Features: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen flex items-center justify-center p-16 sm:p-8 bg-white">
      <div className="flex items-center flex-row md:flex-col w-full max-w-7xl gap-12 md:gap-8">
        {/* Left: Features List */}
        <div className="flex-1 w-full">
          <h2 className="text-tertiary font-bold font-IBMPlex text-4xl sm:text-3xl md:text-5xl mb-8 md:text-center">
            {t.features.title}
          </h2>
          <div className="space-y-6">
            {t.features.items.map((item, index) => (
              <div
                key={index}
                className="flex items-center gap-4 p-4 rounded-lg hover:bg-gray-50 transition-colors"
              >
                <span className="text-4xl">{item.emoji}</span>
                <span className="text-tertiary font-IBMPlex text-xl sm:text-lg md:text-2xl">
                  {item.text}
                </span>
              </div>
            ))}
          </div>
        </div>
        
        {/* Right: Image */}
        <div className="flex-1 flex justify-center items-center">
          <img
            src={assets.homeHero}
            alt="Game preview"
            className="w-full h-full max-w-md object-contain rounded-lg shadow-xl"
          />
        </div>
      </div>
    </div>
  );
};

export default Features;
